import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {Menu} from "antd";
import BusinessListSty from './bussinessList.module.css';

import bussiness_zzsq_icon from '../../images/bussiness_zzsq_icon.png';
import bussiness_zjsq_icon from '../../images/bussiness_zjsq_icon.png';
import bussiness_csfw_icon from '../../images/bussiness_csfw_icon.png';
import bussiness_zxfw_icon from '../../images/bussiness_zxfw_icon.png';
import bussiness_zxzx_icon from '../../images/bussiness_zxzx_icon.png';

import bussiness_zzsq_icon_selected from '../../images/bussiness_zzsq_icon_selected.png';
import bussiness_zjsq_icon_selected from '../../images/bussiness_zjsq_icon_selected.png';
import bussiness_csfw_icon_selected from '../../images/bussiness_csfw_icon_selected.png';
import bussiness_zxfw_icon_selected from '../../images/bussiness_zxfw_icon_selected.png';
import bussiness_zxzx_icon_selected from '../../images/bussiness_zxzx_icon_selected.png';

import {getBusiness, getBusinessCate} from "./service";

const icon = [bussiness_zzsq_icon, bussiness_zjsq_icon, bussiness_csfw_icon, bussiness_zxfw_icon, bussiness_zxzx_icon];
const iconSelect = [bussiness_zzsq_icon_selected, bussiness_zjsq_icon_selected, bussiness_csfw_icon_selected, bussiness_zxfw_icon_selected, bussiness_zxzx_icon_selected];

const BusinessList = (props) => {
    const { history, match } = props;
    const [businessCateData, setBusinessCate] = useState([]);
    const [selectedKey, setSelectedKey] = useState();
    const [openKey, setOpenKey] = useState([]);
    const [businessCon,setBusinessCon] = useState([]);
    const [menuSelectKey,setMenuSelectKey] = useState();

    useEffect(() => {
        (async () => {
            const businessCate = await getBusinessCate({page: 1, size: 100});
            const business = await getBusiness({page: 1, size: 100});


            if(businessCate.data!=null && business!=null){
                businessCate.data.list.map((businessCateItem, index) => {
                    businessCateItem.icon = {select: false, icon: icon[index] || icon[1], iconSelect: iconSelect[index] || iconSelect[1]};
    
                    businessCateItem.children = business.data.list.filter(businessItem => {
                        if (businessItem.cate_id === businessCateItem.id) {
                            return businessItem
                        }
                    });
    
                    businessCateItem.children.map(businessItem => {
                        if(match.params.id && (match.params.id === businessItem.id.toString())) {
                            setOpenKey([openKey,businessItem.cate_id.toString()]);
                            businessCateItem.icon.select = true;
                        }
                    })
                });
            }

            !match.params.id && setOpenKey([openKey,businessCate.data.list[0].id.toString()]);
            !match.params.id && (businessCate.data.list[0].icon.select = true);
            setBusinessCon(business.data.list);

            // history.push({pathname: `/bussiness/${match.params.id || businessCate.data.list[0].children[0].id}`});
            setBusinessCate(businessCate.data.list);
            setMenuSelectKey(openKey[openKey.lastIndex]);
        })();
    }, []);

    useEffect(() => {
        match.params.id && setSelectedKey(match.params.id.toString())
        businessCon.map(businessItem => {
            if(match.params.id && (match.params.id === businessItem.id.toString())) {
                setOpenKey([openKey,businessItem.cate_id.toString()]);
                setMenuSelectKey(businessItem.cate_id);
            }
        })
    }, [match]);

    useEffect(()=>{
        setMenuSelectKey(openKey[openKey.lastIndex]);
    },[menuSelectKey]);

    return(
        <div className={BusinessListSty.listDiv}>
            <div className={BusinessListSty.listTitleSty}>业务范围</div>
            {
                businessCateData.length > 0
                ?    <Menu
                        defaultOpenKeys={openKey}
                        selectedKeys={[selectedKey]}
                        mode="inline"
                        openKeys={openKey}
                        onClick={({keyPath}) => {
                            for (let item of businessCateData) {
                                if( item.id === parseInt(keyPath[1])){
                                    item.icon.select=true;
                                    setOpenKey([openKey,item.id.toString()]);
                                }else{
                                    item.icon.select=false;
                                }
                                // item.icon.select = item.id === parseInt(keyPath[1]);
                            }
                            history.push({pathname: `/bussiness/${keyPath[0]}`})
                        }}
                    >
                        {
                            businessCateData.map(businessCateItem => {
                                const {select, icon, iconSelect} = businessCateItem.icon;
                                // console.log('menuSelectKey='+menuSelectKey)
                                if(businessCateItem.title == '咨询服务')
                                    return false;
                                return(
                                    <Menu.SubMenu
                                        key={businessCateItem.id}
                                        title={
                                            <div style={{display: 'flex', alignItems: 'center', fontSize: 16, fontWeight: 'bold'}}>
                                                <img src={parseInt(menuSelectKey) === parseInt(businessCateItem.id) ? iconSelect : icon} style={{width: 16, height: 16, marginRight: 8}}/>
                                                <span>{businessCateItem.title}</span>
                                            </div>
                                        }
                                        onTitleClick={({key})=>{
                                            for (let businessConItem of businessCon){
                                                if(businessConItem.cate_id.toString() === key.toString()){
                                                    setSelectedKey(businessConItem.id.toString());
                                                    setOpenKey([openKey,key.toString()])
                                                    setMenuSelectKey(key);
                                                    return false;
                                                }
                                            } 
                                            // console.log('MenuCon='+MenuCon)
                                            // if(MenuCon !== null){
                                            //     setOpenKey([openKey,key.toString()])
                                                
                                            // }
                                            // setMenuSelectKey(key);

                                            // for (let item of businessCateData) {
                                            //     if( item.id === parseInt(key)){
                                            //         item.icon.select=true;
                                            //         setOpenKey([openKey,item.id.toString()]);
                                            //     }else{
                                            //         item.icon.select=false;
                                            //     }
                                            // }
                                            
                                        }}
                                    >
                                        {
                                            businessCateItem.children.map(businessItem =>
                                                <Menu.Item key={businessItem.id}>
                                                    <img src={require('../../images/rectangle12.png')} style={{width: 12, height: 12, marginRight: 8}}/>
                                                    {businessItem.title}
                                                </Menu.Item>)
                                        }
                                    </Menu.SubMenu>
                                );
                            })
                        }
                    </Menu>
                :  <div style={{marginBottom: 16, height: 80}}/>
            }
        </div>
    )
};

export default connect()(withRouter(BusinessList));

